<script setup lang="ts">
import SimpleTypeahead from "vue3-simple-typeahead";
import "vue3-simple-typeahead/dist/vue3-simple-typeahead.css"; //Optional default CSS

import { defineEmits } from "vue";
import _ from "lodash";
import { ref } from "vue";

const items = ref([]);

let url: string;

const emit = defineEmits<{
  (e: "onSelect", value: string): void;
  (e: "updateInput", value: string): void;
}>();

function onFetch(e: any) {
  const keyword = e.input;
  url = `/api/autocomplete/${keyword}`;

  if (process.env.NODE_ENV !== "production") {
    url = `${process.env.VUE_APP_LOCAL_URL}/api/autocomplete/${keyword}`;
  }

  if (keyword && !_.isEmpty(keyword)) {
    fetch(url)
      .then((d) => d.json())
      .then((d) => {
        // console.log(d.data)
        items.value = d.data;
      })
      .catch((e) => {
        items.value = [];
        console.error(e);
      });
  } else {
    items.value = [];
  }
}
//
// defineExpose({ fetch })
//
// fetch(keyword)

function itemProjectionFunction(e: any) {
  return `${e.key}: ${e.gene_names}(${e.protein_names})`;
}

function selectedItemProjectionFunction(e: any) {
  return e.key;
}

function selectItemEventHandler(e: any) {
  emit("onSelect", e.key);
}

function onBlurEventHandler(e: any) {
  emit("updateInput", e.input);
}
</script>

<template>
  <simple-typeahead
    class="form-control"
    id="typeahead_id"
    placeholder="Enter search term. (e.g. immunoglobulin)"
    :items="items"
    :minInputLength="1"
    :itemProjection="itemProjectionFunction"
    :selectedItemProjection="selectedItemProjectionFunction"
    @selectItem="selectItemEventHandler"
    @onFetch="onFetch"
    @onBlur="onBlurEventHandler"
  >
  </simple-typeahead>
</template>

<style scoped></style>
